import {ContainerDataAdapter} from "../dashboard/ContainerDataSupplier";
import {ContainerType} from "../dto/com.rico.sb2.entity.detail";
import {AppConfig} from "../AppConfig";
import {createHtmlElement, createSvgElement} from "../lib/domFunctions";

export class ContainerIconCache {
	private readonly cached = new Map<ContainerType, SVGElement>()

	getIcon(type: ContainerType): SVGElement | null {
		if (!type) return null;

		if (!this.cached.has(type)) {
			const typeInfo = AppConfig.ContainerTypes.filter(t => t.type == type)[0];
			if (!typeInfo || !typeInfo.iconSvg) return null;

			const template = createHtmlElement('div', {}, typeInfo.iconSvg)
			const svg = template.querySelector('svg') as SVGElement

			const viewBox = svg.getAttribute('viewBox') as string;
			const viewBoxValues = viewBox.split(/[\s,]+/);
			const [, , w, h] = viewBoxValues
			svg.removeAttribute('viewBox')

			const g = createSvgElement("g")
			g.innerHTML = svg.innerHTML
			g.style.transform = `scale(${16 / parseFloat(w)}, ${16 / parseFloat(h)})`

			this.cached.set(type, g)
		}

		return this.cached.get(type)?.cloneNode(true) as SVGElement || null;
	}
}
